import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { lifeAreaOtherID } from 'shared/types/orderable-section';

export type Options = {
  hiddenLifeAreaIds: ID[];
  hiddenGoalIds: Set<ID>;
  lifeAreaLinkedGoalIds?: ID[];
};

export const filterGoalsByHiddenLifeAreas = (
  goals: Goal[],
  { hiddenLifeAreaIds, hiddenGoalIds, lifeAreaLinkedGoalIds }: Options,
): Goal[] => {
  if (!hiddenLifeAreaIds.length) {
    return goals;
  }

  const hideWithoutLifeArea = hiddenLifeAreaIds.includes(lifeAreaOtherID);
  const linkedGoalIds = new Set(lifeAreaLinkedGoalIds ?? []);

  return goals.filter((goal) => {
    if (hiddenGoalIds.has(goal.id)) {
      return false;
    }

    return !hideWithoutLifeArea || linkedGoalIds.has(goal.id);
  });
};
